export default {
  "meeting": {
    applyrecurring: 'การเปลี่ยนแปลงจะมีผลกับกำหนดการแบบเกิดซ้ำใหม่ ส่วนการประชุมที่ผ่านมา จะไม่ได้รับผลกระทบ',
    recurrenceDescribeTwo: 'เกิดขึ้นทุก {loopPulse} สัปดาห์ในวัน{week} ตั้งแต่ {start} ถึง {end}',
    wanttodeletethemeetingfollowTwo: 'ลบการประชุมที่เลือกและการประชุมที่เกิดซ้ำทั้งหมดหลังจากนี้หรือไม่?',
    loopCycleSelectTips: 'โปรดเลือกวันในสัปดาห์ที่จะทำซ้ำ',

    export: 'ส่งออก',
    exportMeetingFileFuncTipsTitle: 'ยืนยันการส่งออก',
    exportMeetingFileFuncTipsContentOne: 'ไม่ได้ตั้งค่าตัวกรอง ระบบจะส่งออกข้อมูลการประชุมของปีปัจจุบันเป็นค่าเริ่มต้น',
    exportMeetingFileFuncTipsContentTwo: 'หากต้องการส่งออกการประชุมในช่วงเวลาอื่น โปรดตั้งค่าตัวกรองที่ต้องการก่อนส่งออก',

    myMeetingSearch: 'การประชุมของฉัน',
    meetingTimeSearch: 'เวลาการประชุม',
    meetingRoomsSearch: 'ห้องประชุม',

    Recurring: 'เกิดซ้ำ:',
    wanttodeletethemeetingfollow: 'คุณแน่ใจหรือไม่ว่าต้องการลบการประชุมนี้และการประชุมทั้งหมดที่ตามมา?',
    endTimeCannotBeforeBeginTime: 'วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น',
    Thismeeting: 'การประชุมนี้',
    Recurringmeeting: 'การประชุมแบบเกิดซ้ำ',
    Checkin: 'เช็คอิน:',
    checkinTip: 'หลังจากเปิดใช้งาน ผู้เข้าร่วมสามารถเช็คอินได้โดยการสแกนรหัส QR ของระบบจองห้องประชุม',
    Recurrence_Setrecurrence: 'ตั้งค่าการเกิดซ้ำ',
    Recurrence_Start: 'เริ่ม',
    Recurrence_RepeatEvery: 'ทำซ้ำทุก',
    Recurrence_Week: 'สัปดาห์',
    Recurrence_end: 'สิ้นสุด',
    recurrenceDescribe: 'เกิดขึ้นทุก {week} ตั้งแต่ {start} ถึง {end}',
    Recurrence_DoesnotRepeat: 'ไม่ทำซ้ำ',
    Recurrence_Weekly: 'รายสัปดาห์',

    AddressBookUser: 'ผู้ใช้',
    AddressBookPhonebook: 'สมุดรายชื่อ',

    RoomByPeopleNum1: 'ไม่เกิน 2 คน',
    RoomByPeopleNum2: '3-6 คน',
    RoomByPeopleNum3: '7-10 คน',
    RoomByPeopleNum4: '11-15 คน',
    RoomByPeopleNum5: '16-20 คน',
    RoomByPeopleNum6: '21-30 คน',
    RoomByPeopleNum7: 'มากกว่า 30 คน',

    whoAreBound: 'ผู้ใช้ที่ผูกกับบัญชีระบบจะเห็นการประชุมในปฏิทินระบบ ผู้ใช้ที่กรอกอีเมลจะได้รับการแจ้งเตือนทางอีเมล หากต้องการรับการแจ้งเตือน กรุณากรอกข้อมูลอีเมลใน [โปรไฟล์ของฉัน]',

    AttendessMeeting: 'ผู้เข้าร่วม:',
    SelectAttendessMeetingTip: 'เลือกผู้เข้าร่วม',

    MeetingFilter: 'ตัวกรองการประชุม',
    HostedbyMe: 'ฉันเป็นผู้จัด',
    Invitedby: 'ฉันเข้าร่วม',
    Otherby: 'อื่น ๆ',

    "AddressIsDuplicated": "อีเมลผู้ติดต่อซ้ำกัน",
    "meetingExpired": "หมดอายุ",
    titlePhoneFormat: 'หมายเลขโทรศัพท์สามารถกรอกได้เฉพาะตัวเลข, () + และ -',
    "selectField": "โปรดเลือกไฟล์",
    "Limit255": "ชื่อไฟล์ต้องไม่เกิน 255 อักขระ",
    "nameLimit25": "ชื่อต้องไม่เกิน 25 อักขระ",
    "emailLimit50": "อีเมลต้องไม่เกิน 50 อักขระ",
    "emailFormatError": "โปรดป้อนอีเมลที่ถูกต้อง",
    "phoneLimit11": "หมายเลขโทรศัพท์ใส่ได้สูงสุด 11 หลัก",
    "ParticipantsEmail": "อีเมลผู้เข้าร่วม:",
    "listIsEmpty": "รายการว่าง",
    "Startimporting": "เริ่มอัปโหลด",
    "Selectfile": "เลือกไฟล์",
    "Importfile": "นำเข้าไฟล์",
    "ImportfileTip": "*รองรับเฉพาะไฟล์ CSV รูปแบบ Outlook (.csv) หรือไฟล์ vCard (.vcf) สำหรับการนำเข้าเท่านั้น",
    "addParticipants": "เพิ่มผู้เข้าร่วม",
    "multiselectdeselect": "คำแนะนำการลบแท็ก",
    "multiselectselected": "คำแนะนำการเลือก",
    "enterOrSelectALabel": "เลือกอีเมลผู้เข้าร่วม",
    "deleTitleContact": "คุณแน่ใจหรือไม่ว่าต้องการลบรายชื่อนี้?",
    "delTitleContactContent": "ลบรายชื่อ?",
    "deleteContactTitle": "โปรดเลือกรายชื่อที่ต้องการลบ",
    "editcontact": "แก้ไขรายชื่อ",
    "Name": "ชื่อ",
    "email": "อีเมล",
    "telephoneNumber": "โทรศัพท์",
    "Addcontact": "เพิ่มรายชื่อ",
    "Importcontactfile": "นำเข้ารายชื่อ",
    "AddressBook": "สมุดที่อยู่",
    "Participants": "ผู้เข้าร่วม:",

    bindTipContent:"องค์กรนี้ได้ผูกปฏิทินของบุคคลที่สามไว้แล้ว โปรดจัดตารางการประชุมผ่าน Outlook/Teams",
    Productupdatenews: 'มีการเปิดตัวอัปเดตเวอร์ชันใหม่แล้ว',
    bookingPerson: 'จองโดย',
    "DeleteMeeting": "ลบการประชุม",
    "wanttodeletethemeeting": "คุณต้องการลบการประชุมหรือไม่?",
    "hasbeendeleted": "การประชุมถูกลบแล้ว",
    "theMeetingWasAborted": "จบการประชุมก่อนเวลา",
    "theMeetingWasAbortedContent": "คุณต้องการจบการประชุมก่อนเวลาหรือไม่?",
    "determineTheAbortTask": "จบการประชุมก่อนเวลา",
    "theMeetingEndedEarly": "การประชุมสิ้นสุดก่อนเวลา.",
    "with": "กับ",
    "Other": "อื่นๆ",
    "tasks": "การขัดแย้งของงาน",
    "conflict": "เวลาการประชุมต่อไปนี้ขัดแย้ง:",
    "meetConflicts": "ไม่สามารถเลือกเวลาในอดีตได้",
    "itIsNotAllowedToSelectThePastTime": "เลือกแล้ว",
    "selected": "เลือกไม่เกิน 5 ห้องประชุม",
    "noOverFive": "ความคิดเห็นการอนุมัติ",
    "approvalOpinions": "เกินเวลาที่กำหนด ไม่สามารถเลือกได้",
    "beyondTheTimeLimitItCannotBeSelected": "เดือนเริ่มต้น",
    "startMonth": "ถึง",
    "to": "เดือนสิ้นสุด",
    "stopMonth": "ไม่มีการเริ่มต้น",
    "didnTStart": "กำลังดำเนินการ",
    "ONGOING": "สิ้นสุดแล้ว",
    "ENDED": "ได้มี",
    "hasBeen": "การจอง",
    "booking": "การอนุมัติ",
    "Approval": "ห้องประชุม",
    "MeetingRoom": "ทุกห้อง",
    "AllRoom": "พร้อมใช้งาน",
    "Available": "เริ่มประชุม",
    "Initiate": "การอนุมัติการประชุม",
    "MeetingApproval": "เดือนที่ผ่านมา",
    "PreviousMonth": "วันนี้",
    "Today": "เดือนถัดไป",
    "NextMonth": "ปี/เดือน",
    "YearMonth": "การแสดงเวลา",
    "TimeDisplay": "ตัวย่อของชื่อการประชุม",
    "MeetingTitleAbbreviation": "เริ่มประชุม",
    "InitiateMeeting": "การประชุมที่จะมาถึง",
    "PendingMeetings": "การประชุมทั้งหมด",
    "AllMeetings": "ไม่มีการประชุมให้เข้าร่วมในขณะนี้",
    "noMeetings": "ยังไม่เริ่ม",
    "NotStarted": "ผู้จัดงาน",
    "Organizer": "วันที่และเวลา",
    "MeetingDateTime": "สถานที่",
    "MeetingLocation": "หัวข้อการประชุม",
    "MeetingSubject": "ผู้ที่ได้รับเชิญ",
    "Invited": "ผู้ที่ยอมรับ",
    "PeopleAccepted": "แก้ไขการประชุม",
    "EditMeeting": "ยกเลิกการประชุม",
    "CancelMeeting": "เริ่ม/แก้ไขการประชุม",
    "InitiateEditMeeting": "หัวข้อ",
    "Subject": "หัวข้อ",
    "Presenter": "ผู้บรรยาย :",
    "DateTime": "วันที่และเวลา",
    "TimeAndZone": "เขตเวลา",
    "Attendees": "ผู้เข้าร่วม",
    "Addrequiredattendees": "เพิ่มผู้เข้าร่วมที่จำเป็น",
    "SelectRooms": "เลือกห้อง",
    "Reminder": "การเตือนความจำ",
    "Remindbeforestart": "เตือนก่อนเริ่ม",
    "Confirm": "ยืนยัน",
    "topic": "หัวข้อ :",
    "topicplace": "ชื่อเรื่องการประชุมใหม่ :",
    "speaker": "ผู้บรรยาย :",
    "speakerplace": "กรุณากรอกข้อมูลของผู้บรรยาย",
    "DateAndTime": "วันที่และเวลา :",
    "TimeZone": "เขตเวลา",
    "EndDate": "วันที่สิ้นสุด",
    "Rooms": "ห้อง :",
    "Notes": "หมายเหตุ :",
    "MeetingRoomApproval": "การอนุมัติห้องประชุม",
    "PendingApproval": "รอการอนุมัติ",
    "Approved": "อนุมัติ",
    "nopendingapprovals": "ไม่มีการอนุมัติค้างอยู่",
    "Applicant": "ผู้สมัคร",
    "UsageTime": "เวลาการใช้งาน",
    "ApprovalResult": "ผลการอนุมัติ",
    "ApprovalComments": "ความคิดเห็นในการอนุมัติ",
    "Approve": "อนุมัติ",
    "Reject": "ปฏิเสธ",
    "Search": "ค้นหา",
    "Filter": "กรอง",
    "scanTheQRCodeToSignIn": "สแกนรหัส QR เพื่อลงชื่อเข้าใช้"
  },
  "NPS": {
    "Relay": "รีเลย์",
    "RelaySettings": "การตั้งค่ารีเลย์",
    "DevicePower": "การควบคุมพลังงานของอุปกรณ์",
    "DeviceElevation": "การควบคุมการยก",
    "LinageWithNPSPower": "การเชื่อมต่อกับพลังงาน NPS",
    "PresentationSwitch": "สวิตช์การนำเสนอ",
    "Duplicate": "ทำซ้ำ",
    "LinkagewithNPSPowe": "การเชื่อมต่อกับพลังงาน NPS",
    "npsTooltip": "อุปกรณ์ USB สามารถเรียกใช้งานได้เฉพาะจากโฮสต์ PC ที่เชื่อมต่อกับ HDMI OUT 1 เท่านั้น",
    "nmpTooltip": "คลิกที่ปุ่ม 'ทำซ้ำ' เพื่อสะท้อนเนื้อหาจอภาพไปยังจอภาพอื่นๆ และซิงโครไนซ์การแสดงผลบนจอหลายๆ จอ"
  },
  "textTemplate": {
    "template2513": "การแพร่ภาพฉุกเฉินจากเหตุการณ์ไฟไหม้",
    "template2514": "โปรดอพยพออกจากทางออกฉุกเฉินและทางออกไฟไหม้ไปยังสถานที่ปลอดภัยตามแผนการหลบหนีจากไฟไหม้",
    "moreTemplate": "ถึงขีดจำกัดของแม่แบบแล้ว",
    "add": "เพิ่ม",
    "SetTemplate": "ตั้งค่าแม่แบบ",
    "Emergency": "ฉุกเฉิน",
    "General": "ทั่วไป",
    "BroadcastDevices": "อุปกรณ์แพร่ภาพ:",
    "selectBroadcastDevices": "โปรดเลือกอุปกรณ์แพร่ภาพ",
    "All": "ทั้งหมด",
    "AddTemplate": "เพิ่มแม่แบบ",
    "EditTemplate": "แก้ไขแม่แบบ",
    "deleteTemplage": "คุณแน่ใจหรือไม่ว่าต้องการลบแม่แบบที่เลือก?",
    "title": "ลบแม่แบบ",
    "selectTemplage": "โปรดเลือกแม่แบบ!",
    "DeleteCancelled": "การลบถูกยกเลิก!",
    "DeletedSuccessfully": "ลบสำเร็จ!",
    "noData": "ไม่สามารถใช้แม่แบบได้ คลิกที่มุมขวาบนเพื่อเพิ่มแม่แบบ",
    "TemplateTitle": "ชื่อแม่แบบ:",
    "BroadcastType": "ประเภทการแพร่ภาพ:",
    "BroadcastTypeDialog": "ประเภทการแพร่ภาพ:",
    "selectBroadcastType": "โปรดเลือกประเภทการแพร่ภาพ",
    "BroadcastDuration": "ระยะเวลาการแพร่ภาพ:",
    "BroadcastDevice": "อุปกรณ์แพร่ภาพ:",
    "BroadcastContent": "เนื้อหาการแพร่ภาพ:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "ข้อผิดพลาด!",
    "mediaTimeStateNotifyErrorContent": "บริการสตรีมมิ่งของคุณหมดอายุแล้ว โปรดติดต่อตัวแทนของคุณเพื่อทำการต่ออายุให้ทันเวลา",
    "mediaTimeStateNotifyWarnTitle": "คำเตือน!",
    "mediaTimeStateNotifyWarnContent": "คุณอยู่ในสถานะทดลองใช้งาน ซึ่งสามารถส่งสัญญาณและถ่ายทอดสดได้สูงสุด 3 อุปกรณ์",
    "mediaTimeStateNotifySuccessTitle": "การต่ออายุสำเร็จ",
    "mediaTimeStateNotifySuccessContent": "บริการสตรีมมิ่งของคุณพร้อมใช้งานตามปกติ ขอบคุณ",
    "company": "ชื่อบริษัท:",
    "tableAddress": "ที่อยู่:",
    "createTime": "เวลาสร้าง:",
    "email": "อีเมล:",
    "phone": "โทรศัพท์:",
    "Trial": "ทดลอง",
    "TrialWorkstation": "คุณอยู่ในสถานะทดลองใช้งาน ซึ่งสามารถส่งสัญญาณและถ่ายทอดสดได้สูงสุด 3 อุปกรณ์",
    "Normal": "ปกติ",
    "NormalWorkstation": "ระยะเวลาการใช้งานบริการสตรีมมิ่งของคุณคือจาก",
    "to": "ถึง",
    "Advent": "ใกล้จะหมด",
    "AdventWorkstationOne": "บริการสตรีมมิ่งของคุณจะหมดอายุใน",
    "AdventWorkstationTwo": "โปรดติดต่อตัวแทนของคุณเพื่อทำการต่ออายุให้ทันเวลา",
    "Expired": "หมดอายุ",
    "ExpiredWorkstation": "บริการสตรีมมิ่งของคุณหมดอายุแล้ว โปรดติดต่อตัวแทนของคุณเพื่อทำการต่ออายุให้ทันเวลา"
  },
  "route": {
    "dashboard": "แดชบอร์ด",
    "i18n": "I18n",
    "Devices": "อุปกรณ์",
    "Broadcast": "การถ่ายทอด",
    "Schedule": "ตารางเวลา",
    "Resources": "ทรัพยากร",
    "Live": "สตรีมมิ่ง",
    "meetings": "การประชุม"
  },
  "navbar": {
    "updates":"อัปเดตล่าสุด",
    "logOut": "ออกจากระบบ",
    "screenfull": "โหมดเต็มจอ",
    "oprofile": "โปรไฟล์ของฉัน",
    "settings": "การตั้งค่า",
    "language": "ภาษา",
    "BackTianwa": "กลับไปที่ Tianwa",
    "newUserGuide": "คู่มือผู้ใช้ใหม่"
  },
  "feedback": {
    "Feedback": "ข้อเสนอแนะ",
    "email": "โปรดทิ้งอีเมลของคุณเพื่อรับข้อเสนอแนะจากเรา",
    "content": "ยินดีต้อนรับและทิ้งข้อความเพื่อปรับปรุงผลิตภัณฑ์ของเรา ขอบคุณสำหรับความคิดเห็นของคุณ",
    "submit": "ส่ง",
    "emailNoEmpty": "อีเมลไม่สามารถว่างเปล่า",
    "emailTrueRule": "กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง",
    "contentNoEmpty": "เนื้อหาห้ามเป็นค่าว่าง",
    "feedbackSuccess": "ส่งข้อเสนอแนะสำเร็จ",
    "feedbackFailed": "ส่งข้อเสนอแนะล้มเหลว",
    "emailNoChinese": "อีเมลไม่สามารถมีอักขระจีนได้",
    "emailLength": "ยาวระหว่าง 5 ถึง 50 ตัวอักษร",
    "emailSpecialString": "อีเมลไม่สามารถมีสตริงพิเศษได้"
  },
  "login": {
    checkPasswordTitleTwo: 'กรุณาตั้งรหัสผ่านอย่างน้อย 6 ตัวอักษร โดยต้องมีตัวอักษรและตัวเลข สามารถใช้สัญลักษณ์พิเศษได้ (ไม่จำกัด)',
    captcha: 'รหัสยืนยัน',
    checkPasswordTitle: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร และต้องไม่เป็นตัวเลขทั้งหมด',
    "title": "ยินดีต้อนรับ",
    "logIn": "เข้าสู่ระบบ",
    "consoleLogin": "เข้าสู่ระบบคอนโซล",
    "username": "ชื่อผู้ใช้",
    "password": "รหัสผ่าน",
    "any": "ใดๆ",
    "thirdparty": "หรือลงชื่อเข้าใช้ด้วย",
    "thirdpartyTips": "ไม่สามารถจำลองในท้องถิ่นได้ ดังนั้นกรุณารวมกับการจำลองธุรกิจของคุณเอง!",
    "placeholder": ["ชื่อผู้ใช้","รหัสผ่าน","รหัสยืนยัน"],
    "userNameTitle": "ชื่อผู้ใช้ผิด!",
    "forget": "ลืมรหัส?",
    "loginTitle0": "เข้าสู่ระบบสำเร็จ!",
    "loginTitle1000": "ชื่อผู้ใช้หรือรหัสผ่านผิด!",
    "loginTitle1001": "ต้องกรอกชื่อผู้ใช้และรหัสผ่าน!",
    "loginTitle1002": "ต้องกรอกรหัสยืนยัน!",
    "loginTitle1003": "สถานะผู้ใช้ผิดกฎหมาย การเข้าสู่ระบบล้มเหลว!",
    "loginTitle1004": "รหัสยืนยันผิด!",
    "loginTitle1005": "ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน!",
    "loginTitle1006": "รหัสผ่านไม่ตรงกัน!",
    "loginTitleUserName": "ต้องกรอกชื่อผู้ใช้!",
    "loginTitlePwd": "ต้องกรอกรหัสผ่าน!",
    "loginTitleVercode": "ต้องกรอกรหัสยืนยัน!",
    "titleLoginNameFormat": "บัญชีต้องประกอบด้วยตัวอักษร หรือทั้งตัวอักษรและตัวเลข",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "อุปกรณ์",
    "btnRoadcast": "การออกอากาศ",
    "btnResources": "ทรัพยากร",
    "btnLive": "สตรีมมิ่ง",
    "meetings": "การประชุม",
    "todaySchedule": "กำหนดการวันนี้",
    "allSkedules": "กำหนดการทั้งหมด",
    "details": "รายละเอียด",
    "btnStart": "เริ่มต้น",
    "titleContent": "สวัสดี! คอนโซล Q-NEX พร้อมให้บริการแล้ว มาเริ่มกันเลย!",
    "btnExit": "ออก"
  },
  "devices": {
    ptzCamera:'กล้อง PTZ',
    "start": "เริ่ม",
    "stop": "หยุด",
    "nmpPowerOff_mandatory": "กำลังออกอากาศ (ไม่จำเป็น)",
    "nmpPowerOff_nomandatory": "กำลังออกอากาศ (ไม่จำเป็น). ต้องการดำเนินการต่อหรือไม่?",
    "nmpsPowerOff_mandatory": "บาง NMP กำลังออกอากาศ (จำเป็น)",
    "nmpsPowerOff_nomandatory": "บาง NMP กำลังออกอากาศ (ไม่จำเป็น). ต้องการดำเนินการต่อหรือไม่?",
    "reset": "รีเซ็ต",
    "displayedInTheControlArea": "แสดงในศูนย์ควบคุม",
    "dragOrder": "ลากคำสั่ง",
    "areaSettingTwoNotice": "*การควบคุม RS232, AC และการควบคุมระยะไกลจะแสดงในศูนย์ควบคุมตามสถานะการเชื่อมโยง NMP ในแดชบอร์ด",
    "areaSettingThreeNotice": "*การควบคุม CBX จะแสดงในศูนย์ควบคุมตามสถานะการเชื่อมโยง NMP ในแดชบอร์ด",
    "controlSet": "การตั้งค่าศูนย์ควบคุม",
    "vcbNoLine": "ไม่มีอุปกรณ์ CBX ออนไลน์",
    "vcbNoBound": "ไม่มีอุปกรณ์ CBX เชื่อมต่อ",
    "tscNoBound": "RS232 บน TSC ไม่ได้เชื่อมต่อกับข้อมูลใด ๆ โปรดแจ้งผู้ดูแลระบบเพื่อเชื่อมต่อในแดชบอร์ด",
    "light": "การควบคุมพลังงาน",
    "vcbpower": "พลังงาน",
    "rs232Control": "การควบคุมแบบอนุกรม",

    "CBX": {
    "powerSupplyON": "เปิดเครื่อง",
    "powerSupplyOFF": "ปิดเครื่อง",
    "lockScreenON": "ล็อค",
    "lockScreenOFF": "ปลดล็อค",
    "childLockON": "ล็อคเด็กเปิด",
    "childLockOFF": "ล็อคเด็กปิด",
    "energySavingON": "โหมดประหยัดพลังงานเปิด",
    "energySavingOFF": "โหมดประหยัดพลังงานปิด",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "ลำโพง",
    "brightAdjustment": "ความสว่าง",
    "other": "ฟีเจอร์อื่น ๆ..."
  },

    "InterfaceOne": "อินเตอร์เฟซหนึ่ง",
    "InterfaceTwo": "อินเตอร์เฟซสอง",
    "abcStyleP": "ขออภัย! TSC และ (NMP, MBX, NPS, NDP100, NDP500) ไม่สามารถเลือกได้พร้อมกัน",
    "masterControl": "หลัก",
    "powerSupply": "พลังงาน",
    "RecordingControl": "การควบคุมการบันทึก",
    "RecordingControlSystem": "ระบบการจับภาพการบรรยาย",
    "LiquidCrystal": "หน้าจอ LCD แบบอินเตอร์แอคทีฟ",
    "projector": "โปรเจคเตอร์",
    "othertype": "อื่นๆ",
    "lockScreen": "การล็อค",
    "childLock": "ล็อคเด็ก",
    "energySaving": "การประหยัดพลังงาน",
    "signalSourceSwitching": "แหล่งข้อมูลเข้า",
    "volumeAdjustment": "ลำโพง",
    "brightAdjustment": "ความสว่าง",
    "other": "คุณสมบัติอื่นๆ",
    "otherFunction": "ฟังก์ชัน",
    "send": "ส่ง",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "เครื่องปรับอากาศ",
    "titleDevices": "ตัวกรองกลุ่ม:",
    "content": "ค้นหา",
    "selectALL": "เลือกทั้งหมด",
    "SelectRecentPage": "เลือกหน้าปัจจุบัน",
    "controlPanel": "ศูนย์ควบคุม",
    "displayInputSwitch": "สวิตช์อินพุตแสดงผล",
    "chooseINPUTSources": "เลือกแหล่งข้อมูลเข้า",
    "speakerVolume": "ระดับเสียง",
    "bass": "เบส",
    "treble": "แหลม",
    "MICVolume": "ระดับเสียง MIC",
    "AirConditioning": "เครื่องปรับอากาศ",
    "model": "รุ่น",
    "setTemp": "อุณหภูมิที่ตั้งไว้",
    "fanSpeed": "ความเร็วพัดลม",
    "bold": "สวิง",
    "projectionScreen": "หน้าจอโปรเจคเตอร์",
    "electronicLock": "กุญแจไฟฟ้า",
    "electronicLock1": "กุญแจไฟฟ้า",
    "selectDevices": "กรุณาเลือกอุปกรณ์หรือกลุ่มอุปกรณ์",
    "isCompelType": "การควบคุมอุปกรณ์ไม่สามารถใช้งานได้เนื่องจากการถ่ายทอดที่บังคับ กรุณาลองใหม่อีกครั้งในภายหลัง",
    "mainPower": "พลังงานหลัก",
    "extraPower": "พลังงานเสริม",
    "power": "พลังงาน",
    "hdmiBroadcast": "การถ่ายทอด",
    "equipmentState1": "เปิด",
    "equipmentState2": "ปิด",
    "equipmentState3": "ออฟไลน์",
    "main": "หลัก",
    "external": "ภายนอก",
    "ProjectionScreen": "หน้าจอโปรเจคเตอร์",
    "UP": "ขึ้น",
    "DOWN": "ลง",
    "LOCK": "ล็อค",
    "UNLOCK": "ปลดล็อค",
    "PleaseDevice": "กรุณาเลือกอุปกรณ์ทางซ้าย",
    "RemoteControl": "รีโมท",
    "Action": "การกระทำ",
    "Devicefilter": "ตัวกรองอุปกรณ์",
    "DeviceStatus": "สถานะ",
    "DeviceType": "ประเภท",
    "currentAudioSource": "แหล่งเสียงปัจจุบัน",
    "audioSwitching": "สวิตช์เอาท์พุตเสียง"
  },
  "broadcast": {
    "isBoarding": "(ในกระบวนการออกอากาศ)",
    "last3Days": "3 วันล่าสุด",
    "last7Days": "7 วันล่าสุด",
    "last30Days": "30 วันล่าสุด",
    "historyRecord": "ประวัติ",
    "SelectDestination": "1.เลือกปลายทาง",
    "BroadcastingConsole": "2.คอนโซลการออกอากาศ",
    "Notification": "การแจ้งเตือน",
    "btnStop": "หยุด",
    "btnStart": "เริ่ม",
    "Letters60": "(น้อยกว่า 60 ตัวอักษร)",
    "Letters300": "(น้อยกว่า 300 ตัวอักษร)",
    "LastingTime": "ระยะเวลา:",
    "Title": "หัวข้อ:",
    "Content": "เนื้อหา:",
    "Cannotquit": "การออกอากาศที่บังคับ",
    "ChooseMedia": "เลือกไฟล์สื่อ",
    "Broadcasting": "การออกอากาศ",
    "dialogTitle": "ทรัพยากรภาพและเสียง",
    "SortBy": "จัดเรียงโดย",
    "btnBake": "ย้อนกลับไปที่ก่อนหน้า",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "coxAll": "ทั้งหมด",
    "PublicCloud": "พื้นที่จัดเก็บสาธารณะ",
    "IndividualCloud": "พื้นที่จัดเก็บส่วนตัว",
    "selFile": "กรุณาเลือกไฟล์หรือกลุ่ม",
    "StopBroadcast": "หยุดการออกอากาศ",
    "StartBroadcasting": "เริ่มการออกอากาศ",
    "StopBroadcasting": "หยุดการออกอากาศ",
    "ForceQuit": "บังคับหยุด",
    "PleaseMediaFile": "กรุณาเลือกไฟล์สื่อ",
    "PleaseDevice": "กรุณาเลือกอุปกรณ์",
    "broadcast_0": "เริ่มการออกอากาศ",
    "broadcast_2500": "เกินจำนวนอุปกรณ์ที่สามารถเชื่อมต่อกับเซิร์ฟเวอร์สื่อ",
    "broadcast_2501": "ข้อผิดพลาดไฟล์การออกอากาศ",
    "broadcast_2502": "การออกอากาศเสร็จสิ้น",
    "broadcast_2503": "ไม่สามารถรับข้อมูลจากเซิร์ฟเวอร์สื่อได้",
    "broadcast_2510": "ความสนใจ! ขณะนี้คุณอยู่ในสถานะทดลอง สามารถให้คำสั่งการถ่ายทอดสดได้สูงสุด 3 อุปกรณ์เท่านั้น กรุณาตรวจสอบจำนวนอุปกรณ์ที่คุณเลือก",
    "broadcast_2018": "บริการสตรีมมิ่งถูกปิด",
    "broadcast_2019": "บริการสตรีมมิ่งหมดอายุ",
    "broadcast_2512": "เกินจำนวนแม่แบบที่กำหนด",
    "broadcast_2513": "การถ่ายทอดสดเหตุการณ์ฉุกเฉินจากไฟไหม้",
    "broadcast_2514": "กรุณาอพยพจากทางออกฉุกเฉินและทางออกจากไฟไปยังสถานที่ปลอดภัยตามแผนการหนีไฟ",
    "broadcast_2006": "ไม่พบอุปกรณ์",
    "broadcast_2": "บริการดิสก์ผิดปกติ",
    "broadcast_2515": "เลือกอุปกรณ์ที่ไม่มีความสามารถในการถ่ายทอดสด",
    "broadcast_2516": "เลือกไฟล์ที่เกินความละเอียดสูงสุดที่รองรับของ NMP",
    "broadcast_2517": "เลือกไฟล์ที่เกินความละเอียดสูงสุดที่รองรับของ NDP500",
    "broadcast_Title": "การแจ้งเตือนการถ่ายทอดสด",
    "broadcast_TitleNDP500": "การแจ้งเตือนการถ่ายทอดสด NDP500",
    "broadcast_content": "อุปกรณ์รองรับสูงสุดถึง 4K@30FPS โดยมีความละเอียดที่ดีที่สุดที่ 1080P@30FPS",
    "broadcast_contentNDP500": "NDP500/600 รองรับสูงสุดถึง 1080P@30FPS โดยมีความละเอียดที่ดีที่สุดที่ 720P@30FPS",
    "broadcast_noSupported": "วิดีโอที่เลือกต่อไปนี้ไม่รองรับการถ่ายทอดสด:",
    "broadcast_noSupportedNDP500": "วิดีโอที่เลือกต่อไปนี้ไม่รองรับการถ่ายทอดสดบน NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "ชื่อไฟล์ที่อัปโหลดไม่สามารถเกิน 100 คำ!",
    "onUploadFile": "ไม่มีไฟล์สำหรับอัปโหลด",
    "open": "เปิด",
    "fold": "พับ",
    "close": "ปิด",
    "PublicCloud": "ที่จัดเก็บสาธารณะ",
    "IndividualCloud": "ที่จัดเก็บส่วนบุคคล",
    "TransfersHistory": "ประวัติการถ่ายโอน",
    "btnDownload": "ดาวน์โหลด",
    "btnDelete": "ลบ",
    "btnUploadFile": "อัปโหลดไฟล์",
    "btnNewFolder": "โฟลเดอร์ใหม่",
    "btnBake": "กลับไปที่หน้าก่อนหน้า",
    "coxAll": "ทั้งหมด",
    "uploadError": "ขนาดไฟล์ที่อัปโหลดไม่สามารถเกิน 1GB!",
    "MD5": "ตรวจสอบ MD5",
    "merge": "การรวม",
    "transcoding": "การแปลง",
    "uploadFailed": "การอัปโหลดล้มเหลว",
    "fileError": "เกิดข้อผิดพลาดในการอ่านไฟล์โปรดตรวจสอบไฟล์",
    "tableName": "ชื่อ",
    "tableSize": "ขนาด",
    "tableType": "ประเภท",
    "tableTimeAdded": "เวลาที่เพิ่ม",
    "tableAction": "การดำเนินการ",
    "btnRename": "เปลี่ยนชื่อ",
    "btnMoveTo": "ย้ายไป...",
    "ClearAll": "ล้างทั้งหมด",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มล้มเหลว!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "การแก้ไขล้มเหลว!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบไม่สำเร็จ!",
    "diskError3000": "ขนาดพื้นที่รวมเกินไป การดำเนินการล้มเหลว!",
    "diskError3001": "ขนาดพื้นที่สาธารณะเกินไป การดำเนินการล้มเหลว!",
    "diskError3002": "ขนาดพื้นที่ส่วนตัวเกินไป การดำเนินการล้มเหลว!",
    "diskError3003": "ไม่พบข้อมูล กรุณาตรวจสอบว่าเซิร์ฟเวอร์มีเดียถูกผูกไว้หรือไม่!",
    "diskError3004": "ชื่อโฟลเดอร์มีอยู่แล้ว!",
    "diskError3005": "ไม่สามารถดึงโฟลเดอร์ได้!",
    "diskError3006": "ไม่สามารถสร้างโฟลเดอร์ได้เกิน 99 โฟลเดอร์ในระดับเดียวกัน!",
    "diskError3007": "ชื่อไฟล์เดียวกันมีอยู่แล้วและการแก้ไขล้มเหลว!",
    "diskError3008": "ชื่อโฟลเดอร์เดียวกันมีอยู่แล้วและการแก้ไขล้มเหลว!",
    "diskError3009": "ไฟล์เกินพื้นที่ที่เหลือและการอัปโหลดล้มเหลว!",
    "diskError3010": "อัปโหลดไม่สำเร็จ!",
    "diskError3011": "การตรวจสอบไฟล์ล้มเหลว กรุณาอัปโหลดไฟล์ใหม่!",
    "diskError3012": "ไม่สามารถดึงที่อยู่คลาวด์ส่วนตัวได้ การดำเนินการล้มเหลว!",
    "diskError3013": "การรวมไฟล์หลายๆ ไฟล์ไม่สามารถเกิน 100MB ได้ ไฟล์ขนาดใหญ่โปรดดาวน์โหลดแยกต่างหาก!",
    "diskError3014": "การบีบอัดล้มเหลว กรุณาเลือกไฟล์ใหม่สำหรับดาวน์โหลด!",
    "diskError3015": "คุณต้องการสิทธิ์ในการดำเนินการนี้",
    "downloadError": "การดาวน์โหลดล้มเหลว!",
    "mobileError": "การย้ายล้มเหลว!",
    "root": "ทุกไฟล์",
    "Name": "ชื่อ",
    "Size": "ขนาด",
    "Type": "ประเภท",
    "uploadFile": "อัปโหลดไฟล์",
    "newFolder": "โฟลเดอร์ใหม่",
    "tableTime": "เวลา",
    "permission": "สิทธิ์ไม่เพียงพอ!",
    "notifyTitle": "การแจ้งเตือน",
    "notifyContent": "ผู้ใช้ไม่มีสิทธิ์เพียงพอในการเข้าถึง!",
    "sortFileName": "ชื่อไฟล์",
    "sortTime": "เวลา",
    "sortSize": "ขนาด",
    "sortType": "ประเภท",
    "moveTo": "ย้ายไปที่",
    "test": "ใหม่",
    "delTitle": "ลบ?",
    "delTitleContent": "เนื้อหาที่เลือกจะถูกลบจากฐานข้อมูล การดำเนินการไม่สามารถยกเลิกได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน"
  },
  "userMge": {
    "userName": "ชื่อผู้ใช้:",
    "jobNumber": "รหัสพนักงาน:",
    "email": "อีเมล:",
    "phone": "โทรศัพท์:",
    "group": "กลุ่ม:",
    "oldPassword": "รหัสผ่านเก่า:",
    "newPassword": "รหัสผ่านใหม่:",
    "confirmNewPassword": "ยืนยันรหัสผ่านใหม่:",
    "btnSave": "บันทึกการเปลี่ยนแปลง",
    "titleChangePassword": "เปลี่ยนรหัสผ่าน",
    "titleMyProfile": "โปรไฟล์ของฉัน",
    "name": "ชื่อเล่น:",
    "error1400": "บัญชี (ที่กำหนดเอง) มีอยู่แล้ว การดำเนินการล้มเหลว!",
    "error1401": "บัญชี (ที่สร้างโดยระบบ) มีอยู่แล้ว การดำเนินการล้มเหลว!",
    "error1402": "กลุ่มไม่มีอยู่ การนำเข้าล้มเหลว!",
    "error1403": "ข้อผิดพลาดของข้อมูล",
    "error1404": "สิทธิ์ไม่เพียงพอ",
    "selUser": "กรุณาเลือกผู้ใช้!",
    "error1405": "ไม่สามารถดึงบทบาทได้",
    "error1406": "รูปแบบข้อมูลของข้อมูลผู้ใช้นำเข้าผิดพลาด",
    "error1407": "อีเมลมีอยู่แล้ว การดำเนินการล้มเหลว.",
    "error1408": "โทรศัพท์มีอยู่แล้ว การดำเนินการล้มเหลว.",
    "editSuccess": "บันทึกสำเร็จ!",
    "ChangePassword": "เปลี่ยนรหัสผ่าน",
    "UserPrivacyAgreement": "นโยบายความเป็นส่วนตัวของผู้ใช้"
  },
  "information": {
    "_2602": "อุปกรณ์ออฟไลน์",
    "_2603": "การถ่ายทอดล้มเหลว",
    "_2604": "การถ่ายทอดถูกตัดขาด",
    "_2605": "พื้นที่จัดเก็บเต็ม",
    "_2606": "เมื่อสักครู่",
    "_2607": "เมื่อชั่วโมงที่แล้ว",
    "_2609": "ล้มเหลว, กรุณา ",
    "_2609_a": "คลิกที่นี่ ",
    "_2609_time": "เพื่อดำเนินการให้ทันท่วงที",
    "userType": "ผู้ดูแลระบบ",
    "unreadNoticeFirst": "อ่านการแจ้งเตือนก่อน",
    "sortByTime": "จัดเรียงตามเวลา",
    "coxRead_1": "อ่านแล้ว",
    "coxRead_0": "ยังไม่ได้อ่าน",
    "allCoxRead": "ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว",
    "load": "กำลังโหลด...",
    "noData": "ไม่มีข้อมูลเพิ่มเติม",
    "viewALLMessages": "ดูข้อความทั้งหมด"
  },
  "input": {
    "select": "กรุณาเลือก",
    "thisField": "ฟิลด์นี้ต้องกรอก",
    "titleShooleNub60": "น้อยกว่า 60 ตัวอักษร",
    "titleShooleNub300": "น้อยกว่า 300 ตัวอักษร",
    "Offline": "ออฟไลน์"
  },
  "schedule": {
    "OnlyManual": "เพียงแค่ด้วยตนเอง",
    "runStartNow": "เรียกใช้งานงาน",
    "runStopNow": "หยุดงาน",
    "tackExecutionStart": "งานกำลังดำเนินการ",
    "tackExecutionStop": "การดำเนินการของงานถูกหยุด",
    "dehumidification": "การลดความชื้น",
    "airSupply": "การส่งอากาศ",
    "masterControl": "หลัก:",
    "powerSupply": "พลังงาน",
    "lockScreen": "ล็อค",
    "RecordingControl": "การควบคุมการบันทึก",
    "RecordingControlSystem": "ระบบบันทึกการบรรยาย",
    "LiquidCrystal": "หน้าจอ LCD แบบอินเตอร์แอคทีฟ",
    "projector": "โปรเจคเตอร์",
    "othertype": "อื่นๆ",
    "childLock": "ล็อคเด็ก",
    "energySaving": "การประหยัดพลังงาน",
    "signalSourceSwitching": "แหล่งข้อมูลเข้า",
    "other": "คุณสมบัติอื่นๆ:",
    "otherFunction": "ฟังก์ชัน",
    "send": "ส่ง",
    "ON": "เปิด",
    "OFF": "ปิด",
    "btnAddSchedule": "กู้คืน",
    "EditSchedulelist": "แก้ไขตัวจัดตาราง",
    "AddSchedulelist": "เพิ่มตัวจัดตาราง",
    "RestoreSchedulelist": "กู้คืน",
    "btn": "ยกเลิก",
    "btnNewList": "ตัวจัดตารางใหม่",
    "ListName": "ชื่อ",
    "Cannotquit": "จำเป็น",
    "NOCannotquit": "ไม่",
    "ListValidityPeriod": "ระยะเวลาการใช้งาน",
    "ListDescription": "คำอธิบาย",
    "currentSchedule": "รายการตัวจัดตาราง",
    "historySchedule": "ประวัติรายการ",
    "selectTime": "เวลา",
    "selectTimeTable": "เวลา",
    "taskType": "ประเภทงาน",
    "selectBroadcasting": "การออกอากาศ",
    "selectDeviveControl": "การควบคุมอุปกรณ์",
    "newSchedule": "งานใหม่",
    "newChecklist": "รายการตรวจสอบใหม่",
    "titleStatus": "สถานะ",
    "titleType": "ประเภท",
    "titleStartTime": "เวลาที่เริ่ม",
    "titleEndTime": "เวลาที่สิ้นสุด",
    "titleRepeat": "ทำซ้ำ",
    "titleName": "ชื่อ",
    "titleAction": "การดำเนินการ",
    "tableEnabled": "เปิดใช้งาน",
    "tablePaused": "หยุดชั่วคราว",
    "tableEdit": "แก้ไข",
    "tableDelete": "ลบ",
    "tableVolumeEdit": "ระดับเสียงการออกอากาศ",
    "tableBroadcastTitle": "หัวข้อ",
    "tableBroadcastContent": "เนื้อหา",
    "tableBroadcastList": "รายการ",
    "tableBroadcast": "บังคับ",
    "btnRemoveCompletely": "ลบทั้งหมด",
    "btnEnabled": "งานที่เปิดใช้งาน",
    "btnPaused": "ปิดใช้งานงาน",
    "btnDelete": "ลบ",
    "repeat0": "จันทร์",
    "repeat1": "อังคาร",
    "repeat2": "พุธ",
    "repeat3": "พฤหัสบดี",
    "repeat4": "ศุกร์",
    "repeat5": "เสาร์",
    "repeat6": "อาทิตย์",
    "dialogTitleAdd": "งานควบคุมอุปกรณ์ใหม่",
    "dialogTitleEdit": "แก้ไขงานควบคุมอุปกรณ์",
    "newBroadcastingSchedule": "งานถ่ายทอดสดใหม่",
    "editBroadcastingSchedule": "แก้ไขงานถ่ายทอดสด",
    "chooseDevice": "เลือกอุปกรณ์",
    "timeSetting": "การตั้งเวลา",
    "controlBroadcasting": "ตัวเลือกการถ่ายทอดสด",
    "controlOption": "ตัวเลือกการควบคุม",
    "scheduleName": "ชื่องาน:",
    "destination": "ปลายทาง",
    "timeTilte": "เวลา",
    "repeatTitle": "ทำซ้ำ",
    "dialogRepeat0": "จันทร์",
    "dialogRepeat1": "อังคาร",
    "dialogRepeat2": "พุธ",
    "dialogRepeat3": "พฤหัสบดี",
    "dialogRepeat4": "ศุกร์",
    "dialogRepeat5": "เสาร์",
    "dialogRepeat6": "อาทิตย์",
    "dialogOnceType": "ครั้งเดียว",
    "dialogRepeatType": "ทำซ้ำ",
    "Manual": "ด้วยมือ",
    "ManualContent": "คุณสามารถดำเนินการงานเหล่านี้ด้วยตนเองเมื่อคุณเสร็จสิ้นการตั้งค่า",
    "mainPower": "พลังงานหลัก",
    "powerControl": "การควบคุมพลังงาน",
    "tableDisplayInputSwitch": "สลับการแสดงผล",
    "tableAirConditioning": "เครื่องปรับอากาศ",
    "tableProjectionScreen": "หน้าจอโปรเจคเตอร์",
    "tableElectronicLock": "ล็อคไฟฟ้า",
    "interactiveFlatPanel": "แผงแสดงผลแบบโต้ตอบ",
    "displayInputSwitch": "สลับการแสดงผล",
    "speakerVolume": "ระดับเสียง",
    "MICVolume": "ระดับเสียงไมโครโฟน",
    "ProjectionScreen": "หน้าจอโปรเจคเตอร์",
    "ElectronicLock": "ล็อคไฟฟ้า",
    "AirConditioning": "เครื่องปรับอากาศ",
    "AirConditioningPower": "พลังงาน",
    "AirConditioningModel": "รุ่น",
    "AirConditioningTEMP": "อุณหภูมิ",
    "AirConditioningFanSpeed": "ความเร็วพัดลม",
    "OPEN": "เปิด",
    "CLOSE": "ปิด",
    "UP": "ขึ้น",
    "DOWN": "ลง",
    "PowerOFF": "ปิด",
    "PowerON": "เปิด",
    "ModelAuto": "อัตโนมัติ",
    "ModelCool": "เย็น",
    "ModelHeat": "ร้อน",
    "ModelAir": "ทางด้านอากาศ",
    "TEMPLow": "ต่ำ",
    "TEMPMiddle": "กลาง",
    "TEMPHigh": "สูง",
    "btnSave": "บันทึก",
    "btnNext": "ถัดไป",
    "StartTime": "เวลาที่เริ่ม",
    "StopTime": "เวลาหยุด",
    "Mandatory": "บังคับ",
    "Video": "วิดีโอและเสียง",
    "Notification": "การแจ้งเตือน",
    "btnFile": "เลือกไฟล์มีเดีย",
    "LastingTime": "ระยะเวลา",
    "textTitle": "ชื่อเรื่อง",
    "textContent": "เนื้อหา",
    "textTitleLetters": "น้อยกว่า 60 ตัวอักษร",
    "textContentLetters": "น้อยกว่า 320 ตัวอักษร",
    "CannotquitYES": "ใช่",
    "CannotquitNo": "ไม่",
    "YES": "คุณแน่ใจหรือไม่ว่าต้องการลบตารางนี้?",
    "No": "ตารางที่ถูกลบจะถูกย้ายไปยังรายการประวัติและสามารถกู้คืนได้",
    "delTitleContent": "ลบตาราง?",
    "delTitleListContent": "การลบตารางจะทำให้งานที่เกี่ยวข้องถูกลบออก กรุณายืนยัน",
    "deleListTitle": "คุณแน่ใจหรือไม่ว่าต้องการลบตารางนี้?",
    "delTitleListContent1": "ลบ?",
    "deleListTitle1": "ยืนยัน",
    "delTitle": "ทั้งหมด",
    "btnConfirm": "การถ่ายทอด",
    "coxAll": "การควบคุมอุปกรณ์",
    "coxBroadcasting": "ใช่",
    "coxDeviveControl": "ไม่",
    "rdMandatory": "วันที่เริ่มต้น",
    "noRdMandatory": "วันที่สิ้นสุด",
    "startDate": "-",
    "endedDate": "ประเภท",
    "or": "เลือกเวลา",
    "broadcastingType": "เลือกวันที่",
    "ChooseTime": "ตารางใหม่",
    "ChooseDate": "แก้ไขตาราง",
    "newScheduleList": "ชื่อ",
    "editScheduleList": "ระยะเวลาความถูกต้อง",
    "listName": "คำอธิบาย",
    "listValidityPeriod": "ยกเลิก",
    "listDescription": "ยืนยัน",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มล้มเหลว!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขล้มเหลว!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบล้มเหลว!",
    "restoreSuccess": "รายการตารางเวลาได้รับการกู้คืนสำเร็จ",
    "restoreError": "การกู้คืนรายการตารางเวลาล้มเหลว",
    "restoreTitleContent": "เวลานี้ขัดแย้งกับเวลาที่มีอยู่ในรายการ กรุณาเลือกใหม่",
    "Enabled": "เปิดใช้งาน",
    "Paused": "หยุดชั่วคราว",
    "Title": "ชื่อเรื่อง:",
    "Content": "เนื้อหา:",
    "errorScheduleNameRequired": "ต้องกรอกชื่อภารกิจ",
    "errorDeviceRequired": "กรุณาเลือกอุปกรณ์เป้าหมาย",
    "deleTitle": "คุณแน่ใจหรือไม่ว่าจะลบงานนี้?",
    "loopList": "รายการลูป",
    "errorPleaseDateRange": "กรุณาเลือกช่วงวันที่",
    "addError_2009": "ชื่อการตั้งเวลาซ้ำ",
    "conflicts": "เวลาในการทำงานขัดแย้งกับเวลาถัดไป:",
    "Pleaseagain": "กรุณากรอกใหม่",
    "errorScheduleName": "ชื่อภารกิจ",
    "errorListName": "ชื่อการตั้งเวลา",
    "today": "วันนี้",
    "yesterday": "เมื่อวาน",
    "thisWeek": "สัปดาห์นี้",
    "lastWeek": "สัปดาห์ที่แล้ว",
    "lastMonth": "เดือนที่แล้ว",
    "thisMonth": "เดือนนี้",
    "times": "ครั้ง",
    "TimeConflicts": "ความขัดแย้งของเวลา",
    "editError_2006": "ไม่พบอุปกรณ์",
    "editError_2010": "ชื่อภารกิจซ้ำ",
    "editError_2100": "งานหมดอายุแล้วไม่สามารถเริ่มต้นได้",
    "ListTimeExpired": "เวลาของการตั้งเวลาหมดอายุ กรุณาเลือกใหม่",
    "TimeExpired": "หมดเวลา",
    "ControlOption": "ตัวเลือกการควบคุมหายไป",
    "Pleaseleastone": "กรุณาเลือกตัวเลือกการควบคุมอย่างน้อยหนึ่งตัว",
    "Enter": "กรอก",
    "TitleFilled": "ต้องกรอกชื่อเรื่อง",
    "ContentFilled": "ต้องกรอกเนื้อหา",
    "PleaseMediaFile": "กรุณาเลือกไฟล์มีเดีย",
    "PleaseSchedule": "กรุณาเลือกงาน",
    "delTitleScheduleContent": "งานที่ถูกลบไม่สามารถกู้คืนได้",
    "deleTitleSchedule": "คุณแน่ใจหรือไม่ว่าจะลบงานนี้?",
    "deleteScheduleTitle": "กรุณาเลือกงานที่ต้องการลบ",
    "PleaseFillColumn": "กรุณากรอกชื่อการตั้งเวลา",
    "PleaseDate": "กรุณาเลือกวันที่",
    "Previous": "ก่อนหน้า",
    "RemoteControl": "การควบคุมระยะไกล",
    "taskhasexpired": "งานนี้หมดอายุแล้ว กรุณาติดต่อผู้สร้างเพื่ออัปเดตเวลา",
    "execute": "ดำเนินการ",
    "broadcastingList": "รายการออกอากาศ",
    "volumeSuccess": "การตั้งค่าระดับเสียงสำเร็จ",
    "volumeFailed": "การตั้งค่าระดับเสียงล้มเหลว"
  },
  "live": {
    "StreamingRoom": "ห้องสตรีม",
    "btnAddNewRoom": "เพิ่มห้องใหม่",
    "Steaming": "สตรีมมิ่ง",
    "Creater": "โฮสต์:",
    "Address": "ที่อยู่ RTMP:",
    "StreamingURL": "URL การสตรีมสด:",
    "DestinationNMP": "เลือกปลายทาง NMP:",
    "stop": "หยุด",
    "stat": "เริ่ม",
    "btnCope": "คลิกเพื่อคัดลอก",
    "QRcode": "QR โค้ด",
    "Refresh": "รีเฟรช",
    "AddNewRoomTitle": "เพิ่มห้องสตรีมใหม่",
    "editNewRoomTitle": "แก้ไขห้องสตรีม",
    "roomName": "ชื่อห้อง:",
    "cancel": "ยกเลิก",
    "confirm": "ยืนยัน",
    "save": "บันทึก",
    "delTitleContent": "คุณแน่ใจหรือไม่ว่าจะลบตารางนี้?",
    "delTitle": "ลบ?",
    "delCancelButton": "ยกเลิก",
    "delConfirmButton": "ยืนยัน",
    "addSuccess": "เพิ่มสำเร็จ!",
    "addError": "เพิ่มล้มเหลว!",
    "editSuccess": "แก้ไขสำเร็จ!",
    "editError": "แก้ไขล้มเหลว!",
    "delSuccess": "ลบสำเร็จ!",
    "delError": "ลบล้มเหลว!",
    "Stopstreaming": "หยุดการสตรีม",
    "Startstreaming": "เริ่มการสตรีม",
    "error2504": "ไม่สามารถดึงที่อยู่การสตรีมสดจากเซิร์ฟเวอร์มีเดียได้",
    "error2505": "ชื่อห้องสตรีมซ้ำ",
    "error2506": "อุปกรณ์ถูกครอบครองโดยสัญญาณสตรีมอื่น",
    "error1900": "พารามิเตอร์ที่เข้าถึงว่างเปล่า",
    "error2503": "ไม่สามารถดึงข้อมูลจากเซิร์ฟเวอร์มีเดีย",
    "error2507": "ที่อยู่การสตรีมสดซ้ำ",
    "copySuccess": "เนื้อหาถูกคัดลอกไปยังคลิปบอร์ด",
    "copyError": "เบราว์เซอร์ไม่รองรับการคัดลอกอัตโนมัติ",
    "flashControl": "ฟลัชไม่ได้ติดตั้งหรือเปิดใช้งาน โปรดลองใหม่หลังจากติดตั้งหรือเปิดใช้งานฟลัช",
    "liveStreaming": "ไม่พบแหล่งสตรีมสด",
    "btnflash": "ติดตั้ง/เปิดใช้งาน",
    "serverAddress": "ที่อยู่เซิร์ฟเวอร์",
    "addressKey": "คีย์:",
    "watchingAddress": "ที่อยู่การดู",
    "audioOnly": "เสียงเท่านั้น",
    "enterTheKey": "ต้องกรอกคีย์"
  },
  "guidepages": {
    "next": "อุปกรณ์ควบคุมถัดไป",
    "next1": "ลองควบคุมถัดไป",
    "next2": "ถ่ายทอดสดถัดไป",
    "next3": "เริ่มถ่ายทอดสดถัดไป",
    "next4": "หยุดถ่ายทอดสดถัดไป",
    "next5": "ถ่ายทอดสดข้อความถัดไป",
    "next6": "การตั้งค่าหน้าที่ถัดไป",
    "next7": "เพิ่มงานใหม่ถัดไป",
    "next8": "รายการประวัติถัดไป",
    "next9": "คลาวด์สโตเรจถัดไป",
    "next10": "การสตรีมสดถัดไป",
    "next11": "ตั้งค่าการสตรีมสดถัดไป",
    "exit": "ออก",
    "guideContent": "เนื้อหาคู่มือ",
    "btnHomepage": "หน้าแรก",
    "btnDevices": "อุปกรณ์",
    "btnBroadcast": "การถ่ายทอดสด",
    "btnSchedule": "ตารางเวลา",
    "btnResources": "ทรัพยากร",
    "btnStreaming": "การสตรีม",
    "btnPrevious": "ก่อนหน้า"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/th.js